import {
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI,
  PayloadAction,
} from "@reduxjs/toolkit";

import logger from "../utils/logger";
import tokenManager from "../utils/tokenManager";
import type { AppDispatch, RootState } from "./store";

export const apiErrorHandler: Middleware =
  (_api: MiddlewareAPI<AppDispatch, RootState>) =>
  (next) =>
  (action: PayloadAction<{ status: number }>) => {
    if (isRejectedWithValue(action)) {
      if (action.payload.status === 403) {
        logger.warn("Unauthorised");
        tokenManager.removeToken();
      }
      if (action.payload.status === 401) {
        logger.warn("Unauthenticated");
        tokenManager.removeToken();
      }
      logger.warn("Network error", action);
    }
    return next(action);
  };
